import { Popover, PopoverTrigger, Button, PopoverContent } from "@heroui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUp, faEnvelope, faUser } from "@fortawesome/free-solid-svg-icons";


function Upgrade({ name = "James Herrick", email = "james.herrick@sentinelag.tech" }: { name: string | undefined, email: string | undefined }) {
    return (
        <Popover placement="top">
            <PopoverTrigger>
                <Button
                    variant="flat"
                    size="sm"
                    color="primary"
                    aria-label="Upgrade to Full Enrollment"
                    startContent={<FontAwesomeIcon icon={faCircleUp} />}
                >
                    Upgrade
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <div className="px-3 py-2 max-w-xs">
                    <p className="font-semibold text-sm mb-1">
                        Upgrade to Full Enrollment
                    </p>
                    <p className="text-xs text-default-600">
                        Contact your account manager to upgrade to a
                        full enrollment tier.
                    </p>
                    <div className="flex flex-col gap-2 rounded-lg bg-gray-100 text-gray-900 p-3">
                        {name && email && (
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center text-white text-sm shrink-0">
                                    <FontAwesomeIcon icon={faUser} />
                                </div>
                                <div>{name}</div>
                            </div>
                        )}
                        {email && (
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center text-white text-sm shrink-0">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                </div>
                                <div>{email}</div>
                            </div>
                        )}
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    )
}

export default Upgrade;